import React, {useEffect, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {ProgressBarBasic} from "../../../components/progressBar/ProgressBar";
import {
    ContainerTitle,
    InfoContainer,
    InfoContainerTitle,
    InfoItem,
    InfoTitle,
    RentalInfo,
    SubContainer
} from "./rentalAssetViewCss";
import {CodeIdType, CodeSpecNum, CodeType, RentalType} from "../../../constant/CodeSpecNum";
import {useDispatch, useSelector} from "react-redux";
import {
    changeRentalAssetActive,
    getRentalAsset,
    updateRentalAssetCode
} from "../../../api/lifecycle/rental/rentalAssetService";
import {useParams} from "react-router-dom";
import {handleActiveError, handleActiveToast} from "../../../components/sonner/ToastBasic";
import {useTranslation} from "react-i18next";
import {
    approveRentalRequest,
    getRequestRental, rejectRentalRequest,
    returnRentalRequest
} from "../../../api/lifecycle/rental/rentalRequestService";
import {changeRefreshContentAndRentalRequest, changeRefreshContentStatus} from "../../../redux/slice/statusSlice";
import {onUpdate} from "../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../components/selector/Selector";
import RentalHistory from "../rentalHistory/RentalHistory";
import {calculateLeftDateRate, calculateRemainingDays, handleSetUserInfo} from "../../../components/Utils/SimmsUtils";
import RentalAssetModal from "./subPage/RentalAssetModal";
import RentalExtendModal from "./subPage/RentalExtendModal";
import {RentalActiveSwitch} from "../../../components/table/movable/renderer/RentalAssetTableButtonGroup";

const RentalAssetView = () => {
    const [rentalAsset, setRentalAsset] = useState({});

    const {t} = useTranslation();
    const {id} = useParams();

    const refresh = useSelector(state => state.status.refreshContent);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!id) return;
        setRentalAsset({});
        handleCallData();
    }, [id, refresh]);

    const handleCallData = async () => {
        await getRentalAsset(id, (data) => {
            setRentalAsset({...data});
            handleSetRentalCode(data.code)
        });
    }

    const handleSetRentalCode = (code) => {
        if (code && Object.keys(code).length > 0) {
            setRentalAsset((prev) => ({
                ...prev, rentalAssetCode: {...code}, rentalAssetCodeId: code.id
            }))
        }
    }

    const handleUpdateRentalCode = async (id, name) => {
        const data = {...rentalAsset, [name]: id};
        await updateRentalAssetCode(data, () => {
            handleActiveToast({message: t(`updated`)});
            dispatch(changeRefreshContentStatus());
        })
    }

    const handleChangeActive = async () => {
        let data = {id: rentalAsset.id, };
        if (rentalAsset.active) {
            data = {...data, active: false};
        } else {
            data = {...data, active: true};
        }
        await changeRentalAssetActive(data, () => {
            handleActiveToast({message: t(`updated`)});
            dispatch(changeRefreshContentStatus());
        });
    }

    const isRentalAssetDesignated = () => {
        return rentalAsset.rentalType === RentalType.RENT.value
            || rentalAsset.rentalType === RentalType.OCCUPIED.value;
    }

    return (
        <div className="common-container border-l-gray" style={{height: "calc(100vh - 12rem)", display: "flex", flexDirection: "column"}}>
            <PageHeader header={"대여자산관리"} indicator={"라이프사이클 > 자산대여관리 > 상세"}/>
            <div className={'flex border border-gray-300 p-2 gap-6 justify-between shrink-0'}>
                <SubContainer className={'bg-[#f5f5f5] w-[645px]'}>
                    <ContainerTitle>대여자산 정보</ContainerTitle>
                    <InfoContainer>
                        <RentalInfo className={"justify-between"}>
                            <div className={"flex gap-5 w-full"}>
                                <InfoTitle>등록일</InfoTitle>
                                <InfoItem>{rentalAsset.createdAt}</InfoItem>
                            </div>
                            <div className={"flex gap-5 w-full"}>
                                <InfoTitle>수정일</InfoTitle>
                                <InfoItem>{rentalAsset.updatedAt}</InfoItem>
                            </div>
                        </RentalInfo>
                        <RentalInfo>
                            <div className={"flex gap-5 w-full"}>
                                <InfoTitle>자산명</InfoTitle>
                                <InfoItem>{rentalAsset?.asset?.name}</InfoItem>
                            </div>
                            <div className={"flex gap-5 w-full"}>
                                <InfoTitle>자산상태</InfoTitle>
                                <div className={`p-[4px] ${rentalAsset?.asset?.isRemoved && 'text-red-600'}`}>
                                    {rentalAsset?.asset?.isRemoved ? "삭제됨" : "사용가능"}
                                </div>
                            </div>
                        </RentalInfo>
                        <RentalInfo className={"justify-between"}>
                            <div className={"flex gap-5 w-full"}>
                                <InfoTitle>대여상태</InfoTitle>
                                <InfoItem>{rentalAsset?.rentalTypeName}</InfoItem>
                            </div>
                            <div className={"flex gap-5 w-full"}>
                                <InfoTitle>총 대여 횟수</InfoTitle>
                                <InfoItem>{`${rentalAsset.count} 회`}</InfoItem>
                            </div>
                        </RentalInfo>
                    </InfoContainer>
                    <InfoContainer className={"mt-5"}>
                        <InfoContainerTitle>대여 설정</InfoContainerTitle>
                        <RentalInfo>
                            <InfoTitle>대여 그룹</InfoTitle>
                            <InfoItem>
                                <Selector
                                    onChange={(value)=> onUpdate(
                                        setRentalAsset, CodeType.rentalAssetCode, CodeIdType.rentalAssetCodeId,
                                        rentalAsset.rentalAssetCode, value, handleUpdateRentalCode
                                    )}
                                    data={rentalAsset.rentalAssetCode}
                                    entity={"code"}
                                    parentKey={CodeSpecNum.RentalAssetCode}
                                    recursive
                                    auth
                                />
                            </InfoItem>
                        </RentalInfo>
                        <div className={'flex gap-4 border-t-gray-300 pt-[8px]'} style={{borderTop: "solid 1px #d1d5db"}}>
                            <InfoTitle>대여 가능 상태</InfoTitle>
                            <div className={'w-full flex flex-1 items-center justify-between'}>
                                <InfoItem>
                                    {isRentalAssetDesignated()
                                        ? rentalAsset.rentalTypeName
                                        : (rentalAsset.active ? '대여가능' : '대여불가')}
                                </InfoItem>
                                <div className={'mr-[3rem]'}>
                                    {!isRentalAssetDesignated() &&
                                        <RentalActiveSwitch on={!!rentalAsset.active} onClick={handleChangeActive}/>
                                    }
                                </div>
                            </div>
                        </div>
                    </InfoContainer>
                </SubContainer>
                <SubContainer className={'flex-1 h-full'}>
                    <ContainerTitle>현재 대여 상황</ContainerTitle>
                    <div className="w-full h-[1px] bg-[#ccc] mt-[1rem]"></div>
                    {rentalAsset.rentalType === RentalType.AVAILABLE.value && <SteadyRentalAssetInfo rentalAsset={rentalAsset}/>}
                    {isRentalAssetDesignated() && <RentalRequestInfo rentalAsset={rentalAsset} />}
                    {rentalAsset.rentalType === RentalType.UN_AVAILABLE.value && <UnavailableRentalAssetInfo />}
                </SubContainer>
            </div>
            <div className={'border border-gray-300 px-3 pt-2 pb-1 mt-1'} style={{flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
                <RentalHistory rentalInfo={rentalAsset} />
            </div>
        </div>
    );
};

export default RentalAssetView;

const UnavailableRentalAssetInfo = () => {
    return (
        <div className={"mx-8 my-10"}>대여불가 상태입니다.</div>
    )
}

const SteadyRentalAssetInfo = ({rentalAsset}) => {
    return (
        <div className={"flex flex-col"}>
            <div className={"flex gap-20 mx-8 mt-10"}>
                현재 대여중이 아닙니다.
            </div>
            <div className={"flex item-center mt-10 gap-2"}>
                <RentalAssetModal rentalAsset={rentalAsset}/>
            </div>
        </div>
    )
}

const RentalRequestInfo = ({rentalAsset}) => {
    const [rentalRequest, setRentalRequest] = useState({});

    const refresh = useSelector(state => state.status.refreshRentalRequest);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        setRentalRequest({});
        handleCallData();
    }, [rentalAsset?.id, rentalAsset?.rentalRequestId, refresh]);

    const handleCallData = async () => {
        if (rentalAsset.rentalRequestId) {
            await getRequestRental(rentalAsset.rentalRequestId, (data) => {
                setRentalRequest({...data});
            });
        }
    }

    const handleReturn = async () => {
        if (window.confirm(t(`confirmReturnRental`))) {
            const data = {
                rentalAssetId: rentalRequest.rentalAssetId,
                rentalRequestId: rentalRequest.id,
            };
            await returnRentalRequest(data, () => {
                handleActiveToast({message: t(`updated`)});
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle.statusAlreadyChanged`)
                    });
            });
            dispatch(changeRefreshContentAndRentalRequest());
        }
    }

    const handleApprove = async () => {
        if (window.confirm(t(`confirmRent`))) {
            const data = {
                rentalAssetId: rentalRequest.rentalAssetId,
                rentalRequestId: rentalRequest.id,
            };
            await approveRentalRequest(data, () => {
                handleActiveToast({message: t(`complete`)})
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle.statusAlreadyChanged`)
                    });
            });
            dispatch(changeRefreshContentAndRentalRequest());
        }
    }

    const handleReject = async () => {
        if (window.confirm(t(`confirmRejectRental`))) {
            const data = {
                rentalAssetId: rentalRequest.rentalAssetId,
                rentalRequestId: rentalRequest.id,
                rentalType: RentalType.REJECT.value,
            }
            await rejectRentalRequest(data, () => {
                handleActiveToast({message: t(`complete`)});
            }, () => {
                handleActiveError(
                    {
                        message: t(`unableToHandle.message`),
                        description: t(`unableToHandle.statusAlreadyChanged`)
                    });
            });
            dispatch(changeRefreshContentAndRentalRequest());
        }
    }

    return (
        <>
            <div className={"flex gap-20 mx-8 justify-center"}>
                <InfoContainer className={"w-[23rem]"}>
                    <InfoContainerTitle>신청 정보</InfoContainerTitle>
                    <div className={"mt-3"}>
                        <RentalInfo>
                            <InfoTitle>대여 신청일</InfoTitle>
                            <InfoItem>{rentalRequest?.createdAt}</InfoItem>
                        </RentalInfo>
                        <RentalInfo>
                            <InfoTitle>대여 신청자</InfoTitle>
                            <InfoItem>{handleSetUserInfo(rentalRequest.rentUser)}</InfoItem>
                        </RentalInfo>
                        <RentalInfo>
                            <InfoTitle>대여 상태</InfoTitle>
                            <InfoItem>{rentalRequest.rentalTypeName}</InfoItem>
                        </RentalInfo>
                        <RentalInfo>
                            <InfoTitle>대여 기간</InfoTitle>
                            {!rentalRequest.extendDate ?
                                <div>
                                    <div className={"flex gap-[2rem] p-[4px]"}>
                                        <div>{rentalRequest.startDate} ~ {rentalRequest.endDate}</div>
                                        <div>{calculateRemainingDays(rentalRequest.endDate)}</div>
                                    </div>
                                    <ProgressBarBasic done={calculateLeftDateRate(rentalRequest.startDate, rentalRequest.endDate)} total={100}/>
                                </div>
                                :
                                <div>
                                    <div className={"flex gap-[2rem] p-[4px]"}>
                                        <div>{rentalRequest.startDate} ~ {rentalRequest.extendDate}</div>
                                        <div>{calculateRemainingDays(rentalRequest.extendDate)}</div>
                                    </div>
                                    <ProgressBarBasic done={calculateLeftDateRate(rentalRequest.startDate, rentalRequest.extendDate)} total={100}/>
                                </div>
                            }
                        </RentalInfo>
                        <RentalInfo>
                            <InfoTitle>대여 연장일</InfoTitle>
                            <InfoItem>{rentalRequest.extendDate ? `${rentalRequest.extendDate} (기존 반납일 : ${rentalRequest.endDate})` : ''}</InfoItem>
                        </RentalInfo>
                    </div>
                </InfoContainer>
                <InfoContainer className={"w-[23rem]"}>
                    <InfoContainerTitle>담당자 정보</InfoContainerTitle>
                    <div className={"mt-3"}>
                        <RentalInfo>
                            <InfoTitle>대여 승인자</InfoTitle>
                            <InfoItem>{handleSetUserInfo(rentalRequest.rentApprover)}</InfoItem>
                        </RentalInfo>
                        <RentalInfo>
                            <InfoTitle>대여 실행일</InfoTitle>
                            <InfoItem>{rentalRequest.rentApproveDate}</InfoItem>
                        </RentalInfo>
                    </div>
                    <div className={"mt-3"}>
                        <RentalInfo>
                            <InfoTitle>기간연장 승인자</InfoTitle>
                            <InfoItem>{handleSetUserInfo(rentalRequest.extendApprover)}</InfoItem>
                        </RentalInfo>
                        <RentalInfo>
                            <InfoTitle>기간연장 실행일</InfoTitle>
                            <InfoItem>{rentalRequest.extendApproveDate}</InfoItem>
                        </RentalInfo>
                    </div>
                </InfoContainer>
            </div>
            <div className={"flex item-center mt-5 gap-2"}>
                {rentalAsset.rentalType === RentalType.RENT.value &&
                    <>
                        <button className={'btn_green'} onClick={handleReturn}>대여반납</button>
                        {!rentalRequest.extendDate && <RentalExtendModal rentalRequest={rentalRequest}/>}
                    </>
                }
                {rentalAsset.rentalType === RentalType.OCCUPIED.value &&
                    <>
                        <button className={'btn_save'} onClick={handleApprove}>대여승인</button>
                        <button className={'btn_delete'} onClick={handleReject}>대여거절</button>
                    </>
                }
            </div>
        </>
    )
}
